<div class="add-user-page-container container" fxLayout="column">
  <div fxLayout="column" *ngIf="wizard.model.isSearchEnabled">
    <h3 class="mat-h3 color-primary no-bottom-margin">{{ 'ADD_USER.SEARCH.TITLE' | translate }}</h3>
    <mtn-user-autocomplete-field class="default-field-width" [form]="form" controlName="existingUser"
                                 [excludeUuids]="excludedUuids"></mtn-user-autocomplete-field>

    <mtn-simple-panel color="purple" *ngIf="isAssociatedToOtherCompany">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <fa-icon icon="exclamation-triangle" size="2x"></fa-icon>
        <span><strong>{{ 'WARNING' | translate }}</strong> {{ 'ADD_USER.WARNINGS.OTHER_COMPANY' | translate }}</span>
      </div>
    </mtn-simple-panel>

    <mtn-simple-panel color="purple" *ngIf="wizard.model.isDowngraded">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <fa-icon icon="exclamation-triangle" size="2x"></fa-icon>
        <span><strong>{{ 'WARNING' | translate }}</strong> {{ 'ADD_USER.WARNINGS.DOWNGRADED' | translate }}</span>
      </div>
    </mtn-simple-panel>

    <div style="margin-bottom:15px">{{ 'ADD_USER.OR' | translate }}</div>
  </div>

  <h3 class="mat-h3 color-primary no-bottom-margin">{{ 'ADD_USER.CREATE.TITLE' | translate }}</h3>

  <div fxLayout="row" fxLayoutGap="15px">
    <mtn-text-field class="default-field-width" [form]="newUserForm" controlName="firstName"
                    [placeholder]="'ADD_USER.FORM.FIRST_NAME' | translate"></mtn-text-field>
    <mtn-text-field class="default-field-width" [form]="newUserForm" controlName="lastName"
                    [placeholder]="'ADD_USER.FORM.LAST_NAME' | translate"></mtn-text-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" [formGroup]="newUserForm">
    <mtn-email-address-field class="default-field-width" [form]="newUserForm"
                             controlName="email"
                             [placeholder]="'ADD_USER.FORM.EMAIL' | translate"></mtn-email-address-field>

    <mat-form-field class="default-field-width" appearance="outline">
      <mat-select formControlName="type" [placeholder]="'ADD_USER.FORM.USER_TYPE' | translate">
        <mat-option [value]="CompanyInvitationType.ADMINISTRATOR">{{ 'ADD_USER.FORM.ADMIN' | translate }}</mat-option>
        <mat-option [value]="CompanyInvitationType.MEMBER">{{ 'ADD_USER.FORM.MEMBER' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</div>
